module.exports = __webpack_public_path__ + "static/media/codeKingOfTheHill.bcbeaec8.jpg";